import {
  BreakStyle,
  containerBorderRadius,
  defineStylesWithBreaks,
  PageController,
  SquareImage,
  useThemedStylesWithBreaks
} from 'notability-services-common-frontend'

interface DrillDownPreviewArgs {
  images: string[]
}

const style = defineStylesWithBreaks((theme) => {
  const multiPagePreview: BreakStyle = {
    position: 'relative',
    borderBottomLeftRadius: containerBorderRadius,
    borderTopLeftRadius: containerBorderRadius,
    overflow: 'hidden',
    isolation: 'isolate',
    mobile: {
      borderBottomLeftRadius: '0px',
      borderTopRightRadius: containerBorderRadius
    },
    md: {
      borderBottomLeftRadius: '0px',
      borderTopRightRadius: containerBorderRadius
    }
  }

  return {
    container: {
      position: 'relative',
      display: 'flex',
      flex: 4,
      mobile: {
        flex: 'initial'
      },
      md: {
        flex: 'initial'
      },
      lg: {
        flex: 3
      }
    },
    multiPagePreview,
    singlePagePreview: {...multiPagePreview, width: '100%'},
    previewImageStyle: {
      height: '100%',
      width: '100%'
    }
  }
})

export function DrillDownPreview({images}: DrillDownPreviewArgs) {
  const s = useThemedStylesWithBreaks(style)

  const hasMultipleImages = images.length > 1

  const preview = hasMultipleImages ? (
    <PageController enableMouse={true} enableScrollLock={false}>
      {images.map((_) => {
        return <SquareImage key={_} src={_} style={s.previewImageStyle} />
      })}
    </PageController>
  ) : (
    <div style={s.singlePagePreview}>
      <SquareImage src={images[0] ?? ''} style={s.previewImageStyle} />
    </div>
  )

  return <div style={s.container}>{preview}</div>
}
